import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { sortData } from "../../utils/commonMethods";

import CustomDataTable from "../../components/datatable/customDataTable";

import ICNoImg from "../../assets/images/default-picture.png";

const PatientBlockedDoctors = props => {
  const [doctorList, setDoctorList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });

  const filterDocList = () => {
    let newList = doctorList.slice(
      currFilters.skip,
      currFilters.skip + currFilters.limit
    );
    setFilteredList(newList);
  };

  useEffect(() => {
    let list = [];

    props.blockedDoctors.forEach(doctor => {
      let dt = doctor.doctorId;
      dt.fullname = dt.firstName + " " + dt.lastName;
      list.push(dt);
    });

    setDoctorList(list);
    setFilteredList(list);
    setTotalRecords(props.blockedDoctors.length);
  }, [props.blockedDoctors]);

  useEffect(() => {
    filterDocList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const tableHeaders = [
    {
      key: "patientPic",
      value: "Profile Pic",
      sort: false
    },
    {
      key: "doctorId",
      value: "Doctor's UIN"
    },
    {
      key: "fullname",
      value: "Doctor's Name"
    }
  ];

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = parseInt(filters.limit);
      newFilter.skip = parseInt(filters.skip);

      setCurrFilters(newFilter);
    }
  };

  // create custom table filter function
  const customSearchTableByText = query => {
    let newFilteredList = doctorList.filter(doctor => {
      if (doctor.doctorId.includes(query)) {
        return true;
      } else if (doctor.firstName.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (doctor.lastName.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }

      return false;
    });

    setFilteredList(newFilteredList);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, filteredList);
    setFilteredList(sortedData);
  };

  return (
    <div className="view-ticket-container mb-0 pb-0">
      <CustomDataTable
        totalRecords={totalRecords}
        headers={tableHeaders}
        setFilters={setTableFilters}
        sortData={sortTableDataByColumn}
        tabFilters={currFilters}
        disbleAll={true}
      >
        {filteredList.map((doctor, index) => (
          <tr key={index}>
            <td>
              <img
                className="rounded-circle user-img"
                src={
                  doctor.profilePic &&
                  doctor.profilePic.original !== undefined &&
                  doctor.profilePic.original !== null
                    ? doctor.profilePic.original
                    : ICNoImg
                }
                alt="doc-pic"
              />
            </td>
            <td>{doctor.doctorId}</td>
            <td>{doctor.fullname}</td>
          </tr>
        ))}
      </CustomDataTable>
    </div>
  );
};

export default PatientBlockedDoctors;

PatientBlockedDoctors.defaultProps = {
  blockedDoctors: []
};

PatientBlockedDoctors.propTypes = {
  blockedDoctors: PropTypes.array.isRequired
};
